import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { adminApi } from "../../lib/api";
import { inr } from "../landing/usePricing";

const Stars = ({ n }) => (
  <span className="inline-flex">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`h-4 w-4 ${i <= n ? "fill-amber-400 text-amber-400" : "text-slate-400"}`} />)}</span>
);

export const MyRatings = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    adminApi.get("/worker/hk/ratings").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d) return null;
  return (
    <section data-testid="worker-ratings" className="space-y-4 border border-white/10 bg-[#0F172A] p-5">
      <p className="flex items-center gap-2 font-heading text-lg font-bold text-white"><Star className="h-5 w-5 fill-amber-400 text-amber-400" />My ratings & 5★ bonus</p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <div className="border border-white/10 p-3 text-center"><p className="text-xs uppercase text-slate-400">Average rating</p>
          <p data-testid="worker-ratings-avg" className="font-heading text-2xl font-bold text-white">{d.count ? `${d.average} ★` : "—"}</p><p className="text-xs text-slate-500">{d.count} rating(s)</p></div>
        <div className="border border-white/10 p-3 text-center"><p className="text-xs uppercase text-slate-400">5★ ratings</p>
          <p data-testid="worker-ratings-five" className="font-heading text-2xl font-bold text-white">{d.five_star}</p></div>
        <div className="border border-white/10 p-3 text-center"><p className="text-xs uppercase text-slate-400">5★ bonus earned</p>
          <p data-testid="worker-ratings-bonus" className="font-heading text-2xl font-bold text-emerald-300">{inr(d.bonus_total)}</p><p className="text-xs text-slate-500">₹50 per 5★ job</p></div>
      </div>
      {d.items.length === 0 ? <p className="text-sm text-slate-500">No ratings yet. Customers rate after the job is completed.</p> : (
        <div className="space-y-1">
          {d.items.map((r) => (
            <div key={r.reference} data-testid={`worker-rating-${r.reference}`} className="flex flex-wrap items-center justify-between gap-2 border-b border-white/5 py-2 text-sm">
              <span><b className="text-white">{r.service}</b> <span className="font-mono text-xs text-orange-300">{r.reference}</span> · {r.date}</span>
              <span className="flex items-center gap-3"><Stars n={r.rating} />{r.bonus > 0 && <span className="text-emerald-300">+{inr(r.bonus)} bonus</span>}</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
